import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetTenderDetailedInfoQueryResponse, GetTenderDetailedInfoQueryParams, GetTenderDetailedInfo400, GetTenderDetailedInfo401, GetTenderDetailedInfo403, GetTenderDetailedInfo422, GetTenderDetailedInfo429, GetTenderDetailedInfo500 } from "../types/GetTenderDetailedInfo";

export const getTenderDetailedInfoQueryKey = (params?: GetTenderDetailedInfoQueryParams) =>     [{url:`/api/purchase-tenders/private/v1/tender/view_detail-info`},...(params ? [params] : [])] as const;
      export function getTenderDetailedInfoQueryOptions <TData = GetTenderDetailedInfoQueryResponse, TError = GetTenderDetailedInfo400 | GetTenderDetailedInfo401 | GetTenderDetailedInfo403 | GetTenderDetailedInfo422 | GetTenderDetailedInfo429 | GetTenderDetailedInfo500>(params?: GetTenderDetailedInfoQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getTenderDetailedInfoQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/private/v1/tender/view_detail-info`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/private/v1/tender/view_detail-info
 */

export function useGetTenderDetailedInfo <TData = GetTenderDetailedInfoQueryResponse, TError = GetTenderDetailedInfo400 | GetTenderDetailedInfo401 | GetTenderDetailedInfo403 | GetTenderDetailedInfo422 | GetTenderDetailedInfo429 | GetTenderDetailedInfo500>(params?: GetTenderDetailedInfoQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getTenderDetailedInfoQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getTenderDetailedInfoQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
